import { render, staticRenderFns } from "./SoMeVideo.vue?vue&type=template&id=012cf058&"
import script from "./SoMeVideo.vue?vue&type=script&lang=js&"
export * from "./SoMeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports